import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Order } from 'src/app/models/order.model';
import { SettlementsService } from 'src/app/services/settlements.service';

@Component({
  selector: 'app-order-create',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Combustible</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul app-nav-tanques [currentView]="currentView" class="list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Pedido</h2>            
            <p class="text-muted" style="font-size: 14px;">Configura los pedidos que están disponibles para los departamentos.</p>
            <xng-breadcrumb ></xng-breadcrumb>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-fill">
            <div class="list-group rounded-4 rounded-md-5 mt-4">
              <div class="list-group-item table-responsive py-4">
              <app-form-order (orderData)="createOrder($event)" [order]="order" [loading]="loading"></app-form-order>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </div>
    
  `,
  styleUrls: []
})
export class OrderCreateComponent {
  order: Order | null = null;
  loading: boolean = false;
  currentView: string = 'orders';

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  createOrder(event: any) {
    this.store.createPurchaseOrder(event).subscribe({
      next: (data: any) => {
        console.log(data);
        this.toastr.success('Servicio creado correctamente.');
        this.router.navigate(['/combustibles/orders']);
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error('Ocurrió un error al crear el servicio.');
      }
    });
  }
}
